import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import sentry_init from './utils/sentry';

sentry_init();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
